// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".face-move[data-v-e2e74a7a],.fade-enter-active[data-v-e2e74a7a],.fade-leave-active[data-v-e2e74a7a]{transition:opacity .2s}.fade-enter[data-v-e2e74a7a],.fade-leave-to[data-v-e2e74a7a]{opacity:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
